import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import RowTranslation from '@/repositories/data/content/row/RowTranslation';
import HttpClient from '@/util/http/HttpClient';

export default class RowTranslationRepository extends BaseCrudRepository<number, RowTranslation, RowTranslation> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/row-translation/');
    }
}
